<div class="tag-sourcing-container">
  <div class="paddingTop">
    <div class="form-row">
      <div class="form-group col-sm-4">
        <label>Tag Key</label>
        <input type="text" class="form-control" placeholder="Enter Tag Key" [(ngModel)]="tagData.tagKey" />
      </div>
      <div class="form-group col-sm-4">
        <label>Alt Gie key</label>
        <input type="text" class="form-control" placeholder="Enter Alt Gie Key" [(ngModel)]="tagData.gieKey" />
      </div>
      <div class="form-group col-sm-4">
        <label>Acct key</label>
        <input type="text" class="form-control" placeholder="Enter Acct Key" [(ngModel)]="tagData.actKey" />
      </div>
    </div>
    <div class="form-row paddingTop">
      <div class="form-group col-sm-4">
        <label>Combination Key</label>
        <input type="text" class="form-control" placeholder="Enter Combination Key" [(ngModel)]="tagData.combinationKey" />
      </div>
      <div class="form-group col-sm-4">
        <label>Trans Type</label>
        <select class="form-control" [(ngModel)]="tagData.transType">
          @for (x of transTypes; track $index) {
<option [value]="x">{{ x }}</option>
}
        </select>
      </div>
      <div class="form-group col-sm-4">
        <label>Dropdown</label>
        <select class="form-control" [(ngModel)]="tagData.dropdown">
          @for (x of names; track $index) {
<option [value]="x">{{ x }}</option>
}
        </select>
      </div>
    </div>
    <div class="form-row paddingTop">
      <div class="form-group col-sm-4">
        <label>Amount</label>
        <input type="text" class="form-control" placeholder="Enter Amount" [(ngModel)]="tagData.amount" />
      </div>
      <div class="form-group col-sm-2 padding-top-btn">
        <button type="button" class="save-button" [disabled]="isSaveClicked" (click)="save()">
          @if (showJsonLoader) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
        </button>
      </div>
    </div>
  </div>
</div>
